var chunkToChildrenMap = {
	"115": [
		5284,
		1305,
		6859,
		3169,
		8194,
		4440,
		3835,
		7020
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));